import { createAction } from '@reduxjs/toolkit';

import type { CreateTranscriptCorrectionsPayload } from '@polyai/stream/commands/handlers/transcript-corrections/create-transcript-corrections/schema';
import type { DeleteTranscriptCorrectionsPayload } from '@polyai/stream/commands/handlers/transcript-corrections/delete-transcript-corrections/schema';
import type { UpdateTranscriptCorrectionsPayload } from '@polyai/stream/commands/handlers/transcript-corrections/update-transcript-corrections/schema';

import { TRANSCRIPT_CORRECTIONS_SLICE_NAME } from './constants';

export const updateTranscriptCorrectionsAction =
  createAction<UpdateTranscriptCorrectionsPayload>(
    `${TRANSCRIPT_CORRECTIONS_SLICE_NAME}/updateTranscriptCorrections`,
  );

export const createTranscriptCorrectionsAction =
  createAction<CreateTranscriptCorrectionsPayload>(
    `${TRANSCRIPT_CORRECTIONS_SLICE_NAME}/createTranscriptCorrections`,
  );

export const deleteTranscriptCorrectionsAction =
  createAction<DeleteTranscriptCorrectionsPayload>(
    `${TRANSCRIPT_CORRECTIONS_SLICE_NAME}/deleteTranscriptCorrections`,
  );
